// extracted by mini-css-extract-plugin
export default {"formHeading":"tI-z","form":"uI-z","submitBtn":"vI-z","disabled":"wI-z","input":"xI-z","error":"yI-z","submitMsg":"zI-z","signIn":"AI-z"};